module.exports = __webpack_public_path__ + "static/media/save.caadaa3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/save.png
// module id = 169
// module chunks = 0